import api from './api';
import { authService } from './authService';

export const employeeService = {
    getEmployees: async () => {
        try {
            const restaurantId = authService.getCurrentRestaurantId();
            const response = await api.get(`/api/business/employee?restaurant=${restaurantId}`);
            return response.data.data || [];
        } catch (error) {
            console.error('Get employees error:', error);
            return [];
        }
    },

    createEmployee: async (employeeData) => {
        try {
            const restaurantId = authService.getCurrentRestaurantId();
            
            // Telefon numarasını temizle (sadece rakamları tut)
            const cleanPhone = employeeData.phone.replace(/[^\d]/g, '');
            
            // Temizlenmiş telefon numarasını kullan
            const data = { 
                ...employeeData, 
                phone: cleanPhone.length === 10 ? 
                    `(${cleanPhone.slice(0, 3)})${cleanPhone.slice(3)}` : 
                    employeeData.phone,
                restaurant: restaurantId 
            };
            
            const response = await api.post('/api/business/employee', data);
            return response.data || {};
        } catch (error) {
            console.error('Create employee error:', error);
            throw error;
        }
    },

    deleteEmployee: async (employeeId) => {
        try {
            const response = await api.delete(`/api/business/employee/${employeeId}`);
            return response.data.data || {};
        } catch (error) {
            console.error('Delete employee error:', error);
            throw error;
        }
    },

    getEmployeesForTasks: async () => {
        try {
            const restaurantId = authService.getCurrentRestaurantId();
            const response = await api.get(`/api/business/employee?restaurant=${restaurantId}&active=true`);
            return response.data.data || [];
        } catch (error) {
            console.error('Get employees for tasks error:', error);
            return [];
        }
    },
    
    getEmployeeTaskPerformance: async () => {
        try {
            const restaurantId = authService.getCurrentRestaurantId();
            const response = await api.get(`/api/business/employee/performance?restaurant=${restaurantId}`);
            return response.data || [];
        } catch (error) {
            console.error('Get employee task performance error:', error);
            return [];
        }
    },
    
    getOverdueTasks: async () => {
        try {
            const restaurantId = authService.getCurrentRestaurantId();
            const response = await api.get(`/api/business/employee/overdue-tasks?restaurant=${restaurantId}`);
            return response.data || [];
        } catch (error) {
            console.error('Get overdue tasks error:', error);
            return [];
        }
    },
    
    getEmployeeOrderAnalytics: async () => {
        try {
            const response = await api.get('/api/business/employee/order-analytics');
            return response.data.data || [];
        } catch (error) {
            console.error('Get employee order analytics error:', error);
            return [];
        }
    }
};